export default "__VITE_ASSET__J3WPjP1v__"